"use client";

import type { CSSProperties } from "react";

export type ActiveCell = {
  x: number;
  y: number;
  piece: number;
};

type BattleBoardProps = {
  active?: ActiveCell[];
  board: number[][];
  label: string;
  local?: boolean;
  topOut?: boolean;
};

const cellStyle = (value: number): CSSProperties =>
  ({ "--piece": value } as CSSProperties);

export function BattleBoard({
  active = [],
  board,
  label,
  local = false,
  topOut = false,
}: BattleBoardProps) {
  const activeByIndex = new Map(
    active
      .filter(({ x, y }) => x >= 1 && x <= 10 && y >= 1 && y <= 24)
      .map((cell) => [((cell.y - 1) * 10 + (cell.x - 1)), cell.piece]),
  );

  const cells = Array.from({ length: 240 }, (_, index) => {
    const row = Math.floor(index / 10);
    const column = index % 10;
    const fixed = board[row]?.[column] ?? 0;
    const moving = activeByIndex.get(index) ?? 0;
    const value = moving || fixed;

    return (
      <span
        aria-hidden="true"
        className={`board-cell${value ? " tile" : ""}${moving ? " active-tile" : ""}`}
        key={index}
        style={cellStyle(value)}
      />
    );
  });

  return (
    <section
      aria-label={label}
      className={`battle-board${local ? " local-board" : ""}${topOut ? " top-out" : ""}`}
    >
      <div className="board-bevel">
        <div className="board-well">
          <div className="board-grid">{cells}</div>
          <div aria-hidden="true" className="defeat-zone" />
        </div>
      </div>
      <div className="seat-label">
        <span className="seat-dot" />
        {label}
      </div>
    </section>
  );
}

